import React from 'react';
import {
  Typography, Box, Grid, Button,
} from '@mui/material';
import StyledBox, {
  StyledImgBox,
} from 'views/common/components/UI/OffRoadPromotionBanner/OffRoadPromotionBanner.styles';
import { useTranslation } from 'next-i18next';
import Typography500 from 'views/common/components/UI/Typography500';
import { ImgBox } from 'views/common/components';
import NavigatorLink from 'views/rebranded-module/common/components/Logical/NavigatorLink';
import PATHS from 'lib/navigation/paths';

const OffRoadPromotionBanner = () => {
  const { t } = useTranslation('fe_er_common_off_road_promotion_banner');
  const bgImg = {
    large: '/imgs/off-road/confirmation-promo.png',
    medium: '/imgs/off-road/confirmation-promo.png',
    small: '/imgs/promotionSM.png',
    alt: 'background-img',
  };

  return (
    <StyledBox>
      <Grid container className="ORPBGridContainer">
        <Grid item xs={12} md={6} lg={6}>
          <Box className="showMOBILE ORPBImgContainer">
            <StyledImgBox
              image={{
                src: bgImg.small,
                alt: bgImg.alt,
              }}
              imgWidth="100%"
              imgHeight="100%"
              objectFit="cover"
            />
          </Box>
          <Box className="showTABLET ORPBImgContainer">
            <StyledImgBox
              image={{
                src: bgImg.medium,
                alt: bgImg.alt,
              }}
              imgWidth="100%"
              imgHeight="100%"
              objectFit="cover"
            />
          </Box>
          <Box className="showDESKTOP ORPBImgContainer">
            <StyledImgBox
              image={{
                src: bgImg.large,
                alt: bgImg.alt,
              }}
              imgWidth="100%"
              imgHeight="100%"
              objectFit="cover"
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={6} lg={6} position="relative">
          <ImgBox
            image={{
              src: '/imgs/patterns/asphalt-pattern.png',
              alt: 'Asphalt pattern',
            }}
            className="ORPBBGRightImg"
          />
          <Box className="ORPBTextContainer">
            <Typography500 className="ORPBTitle drukFamily">
              {t('fe_er_common_off_road_promotion_banner:title')}
            </Typography500>
            <Typography500 className="ORPBSubTitle drukFamily" mb={1}>
              {t('fe_er_common_off_road_promotion_banner:sub_title')}
            </Typography500>
            <Typography className="showDESKTOP" variant="body1">
              {t('fe_er_common_off_road_promotion_banner:description')}
            </Typography>
            <Button
              component={NavigatorLink}
              variant="contained"
              className="ORPBBtn"
              href={PATHS.guidedOffroadTour.index()}
              color="primary">
              {t('fe_er_common_off_road_promotion_banner:book_now')}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </StyledBox>
  );
};

export { OffRoadPromotionBanner };
